import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_RELOAD,
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: false,
  success: false,
  email: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_PASSWORD: {
      return { loader: true };
    }
    case RESET_PASSWORD_SUCCESS: {
      return { loader: false, success: true, email: action.payload.email };
    }
    case RESET_PASSWORD_ERROR: {
      return { loader: false };
    }
    case RESET_PASSWORD_RELOAD: {
      return { loader: false, success: false, email: '' };
    }
    default:
      return state;
  }
};
